"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiTabsOverrides = void 0;
var createMuiTabsOverrides = function (_a) {
    var palette = _a.palette;
    return ({
        root: {
            minHeight: undefined,
        },
        indicator: {
            backgroundColor: palette.text.primary,
        },
    });
};
exports.createMuiTabsOverrides = createMuiTabsOverrides;
//# sourceMappingURL=MuiTabs.js.map